<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="color">mdi-thermometer</v-icon>
      </template>
      <template #value>{{ !isNaN(temperature) ? temperature.toFixed(1) : '---' }}</template>
      <template #unit>{{ unit }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <TemperatureChartDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" :reportInterval="reportInterval" :reportUnit="reportUnit" :desiredUnit="desiredUnit" :unit="unit" @setting="showSettingsDialog">
  </TemperatureChartDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import TemperatureChartDialog from '@/components/chart/TemperatureChartDialog'

export default {
  name: 'TemperatureTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    TemperatureChartDialog
  },
  props: {
    desiredUnit: {
      type: String
    }
  },
  computed: {
    temperature() {
      return this.transformByUnit(this.report.temperature || NaN);
    },
    reportUnit() {
      return this.info.configurations.reportUnit;
    },
    reportInterval() {
      return this.info.configurations.reportInterval;
    },
    unit() {
      let u = this.desiredUnit || this.reportUnit;
      if (u)
        return this.$t(`unit.${u}`);
      else
        return '';
    },
    color() {
      return isNaN(this.temperature) ? 'grey' : 'primary';
    }
  },
  methods: {
    transformByUnit(value) {
      if (this.reportUnit == 'C' && this.desiredUnit == 'F') return value * 9 / 5 + 32;
      if (this.reportUnit == 'F' && this.desiredUnit == 'C') return (value - 32) * 5 / 9;
      return value;
    }
  }
}
</script>
